import { render, staticRenderFns } from "./expiredChangeRecord.vue?vue&type=template&id=155f1de5&scoped=true&"
import script from "./expiredChangeRecord.vue?vue&type=script&lang=js&"
export * from "./expiredChangeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155f1de5",
  null
  
)

export default component.exports